export default "__VITE_ASSET__DaEIewJF__"